import { ChatScreen } from "../screens/chat/ChatScreen";
import { AddPhoneModal } from "../components/AddPhoneModal";

/**
 * Beyond Sure — /chat route.
 *
 * Phase 1: mounts the Claude-fidelity chat shell (sidebar + centered
 * message column + mobile drawer + composer + streaming mock).
 *
 * Phase 2 will extend ChatScreen with rich message blocks; Phase 3
 * with tailored starters, real upload, and API wiring. Until then
 * the entire surface is independent — no backend calls.
 *
 * AddPhoneModal: nudges email-signup users to attach a phone for SMS
 * alerts and faster re-sign-in. The modal itself reads
 * PHONE_CAPTURE_POPUP_ENABLED + checks the cached user blob to decide
 * whether to render, so this mount is a no-op until the founder flips
 * the flag in lib/featureFlags.ts. Putting the gate INSIDE the modal
 * (not here) means ChatRoute doesn't need to know anything about
 * eligibility logic.
 */
export function ChatRoute() {
  return (
    <>
      <ChatScreen />
      <AddPhoneModal />
    </>
  );
}

export default ChatRoute;
